import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/components/theme-provider"
import { cn } from "@/lib/utils"

export function ModeToggle() {
    const { setTheme, theme } = useTheme()

    return (
        <div className="flex items-center space-x-2 border rounded p-1 bg-gray-100 dark:bg-gray-800">
            <button
                onClick={() => setTheme("light")}
                className={cn("p-2 rounded hover:bg-white dark:hover:bg-gray-700 transition-all", theme === 'light' && "bg-white shadow text-black")}
                title="Light Mode"
            >
                <Sun className="h-[1.2rem] w-[1.2rem]" />
            </button>
            <button
                onClick={() => setTheme("dark")}
                className={cn("p-2 rounded hover:bg-white dark:hover:bg-gray-700 transition-all", theme === 'dark' && "bg-gray-700 shadow text-white")}
                title="Dark Mode"
            >
                <Moon className="h-[1.2rem] w-[1.2rem]" />
            </button>
            <button
                onClick={() => setTheme("system")}
                className={cn("p-2 text-xs font-medium rounded hover:bg-white dark:hover:bg-gray-700 transition-all", theme === 'system' && "bg-white dark:bg-gray-700 shadow")}
                title="System Mode"
            >
                Auto
            </button>
        </div>
    )
}
